<template>
    <v-dialog v-model="mostrar" persistent max-width="600px">
        <v-card :loading="loading">
            <v-card-title>
            <span class="headline">Nuevo gasto</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="3" md="3">
                            <v-menu
                                v-model="fechaPicker"
                                :close-on-content-click="false"
                                max-width="290"
                                >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                    :value="fechaTexto"
                                    label="Fecha:"
                                    readonly
                                    v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="fecha"
                                    locale="es"
                                    @change="fechaPicker = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-model="cheque" 
                                name="SG-NU-cheque" 
                                label="Cheque/Vale:"
                                :error-messages="errors.cheque"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-model="solicitud" 
                                name="SG-NU-solicitud" 
                                label="Solicitud:"
                                :error-messages="errors.solicitud"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field 
                                v-model="solicita" 
                                name="SG-NU-solicita" 
                                label="Solicita:"
                                :error-messages="errors.solicita"
                                @input="validarSolicita()"
                                @blur="validarSolicita()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field 
                                v-model="concepto" 
                                name="SG-NU-concepto" 
                                label="Concepto:"
                                :error-messages="errors.concepto"
                                @input="validarConcepto()"
                                @blur="validarConcepto()"
                                >
                            </v-text-field>
                        </v-col>
                        
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-model="comprometido" 
                                name="SG-NU-comprometido" 
                                label="Comprometido:"
                                :error-messages="errors.comprometido"
                                @input="validarComprometido()"
                                @blur="validarComprometido()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-model="devengado" 
                                name="SG-NU-devengado" 
                                label="Devengado:"
                                :error-messages="errors.devengado"
                                @input="validarDevengado()"
                                @blur="validarDevengado()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-model="comprobado" 
                                name="SG-NU-comprobado" 
                                label="Comprobado:"
                                :error-messages="errors.comprobado"
                                @input="validarComprobado()"
                                @blur="validarComprobado()"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="teal darken-1" outlined text @click="$emit('cancelar')">Cancelar</v-btn>
            <v-btn color="teal darken-1" dark @click="guardarGasto()">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
       
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, integer, decimal } from 'vuelidate/lib/validators'
import axios from 'axios'
import { mapGetters} from 'vuex'
import moment from 'moment'
moment.locale('es');

export default {
    props:['mostrar','idPartida'],
    mixins: [validationMixin],
    data: () => ({
        loading: false,
        fecha: moment().format('YYYY-MM-DD'),
        fechaPicker: false,
        cheque: null,
        solicita: null,
        solicitud: null,
        concepto: null,
        comprometido: 0,
        devengado: 0,
        comprobado: 0,
        errors:{
            cheque: [],
            solicita: [],
            solicitud: [],
            concepto: [],
            comprometido: [],
            devengado: [],
            comprobado: []
        },
    }),
    validations: {
        //cheque: { required },
        solicita: { required },
        //solicitud: { required },
        concepto: { required },
        comprometido: { required, decimal },
        devengado: { required, decimal },
        comprobado: { required, decimal }
    },
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken"
        ]),
        fechaTexto(){
            return this.fecha ? moment(this.fecha).format('DD/MM/YYYY') : ''
        },
    },
    created(){
    },
    methods: {
        validarCheque(){
            this.$v.cheque.$touch();
            const errors = []
            if (this.$v.cheque.$dirty){
                !this.$v.cheque.required && errors.push('Campo requerido.')
            }
            this.errors.cheque = errors;
        },
        validarSolicitud(){
            this.$v.solicitud.$touch();
            const errors = []
            if (this.$v.solicitud.$dirty){
                !this.$v.solicitud.required && errors.push('Campo requerido.')
            }
            this.errors.solicitud = errors;
        },
        validarSolicita(){
            this.$v.solicita.$touch();
            const errors = []
            if (this.$v.solicita.$dirty){
                !this.$v.solicita.required && errors.push('Campo requerido.')
            }
            this.errors.solicita = errors;
        },
        validarConcepto(){
            this.$v.concepto.$touch();
            const errors = []
            if (this.$v.concepto.$dirty){
                !this.$v.concepto.required && errors.push('Campo requerido.')
            }
            this.errors.concepto = errors;
        },
        validarComprometido(){
            this.$v.comprometido.$touch();
            const errors = []
            if (this.$v.comprometido.$dirty){
                !this.$v.comprometido.required && errors.push('Campo requerido.')
                !this.$v.comprometido.decimal && errors.push('Debe ingresar un número.')
            }
            this.errors.comprometido = errors;
        },
        validarDevengado(){
            this.$v.devengado.$touch();
            const errors = []
            if (this.$v.devengado.$dirty){
                !this.$v.devengado.required && errors.push('Campo requerido.')
                !this.$v.devengado.decimal && errors.push('Debe ingresar un número.')
            }
            this.errors.devengado = errors;
        },
        validarComprobado(){
            this.$v.comprobado.$touch();
            const errors = []
            if (this.$v.comprobado.$dirty){
                !this.$v.comprobado.required && errors.push('Campo requerido.')
                !this.$v.comprobado.decimal && errors.push('Debe ingresar un número.')
            }
            this.errors.comprobado = errors;
        },
        ordenarPartidas(){
            this.partidas.sort((a,b)=>(a.numero > b.numero) ? 1 : ((b.numero > a.numero) ? -1 : 0));
        },
        guardarGasto(){
            this.$v.$touch();
            //this.validarCheque();
            //this.validarSolicitud();
            this.validarSolicita();
            this.validarConcepto();
            this.validarComprometido();
            this.validarDevengado();
            this.validarComprobado();
            if (!this.$v.$invalid) {
                this.loading = true;
                axios.post(this.httpURL+'/partidas/gastos/'+this.idPartida,
                {
                    fecha: this.fecha,
                    cheque: this.cheque,
                    solicitud: this.solicitud,
                    solicita: this.solicita,
                    concepto: this.concepto,
                    comprometido: this.comprometido,
                    devengado: this.devengado,
                    comprobado: this.comprobado
                },
                {headers:{token:this.sessionToken}})
                .then(res => {
                    // console.log(res.data);
                    if( res.data.ok ){
                        this.$emit('gastoAgregado');
                        this.loading = false;
                    }else{
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                        this.loading = false;
                    }
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
            }
        }
    }
}
</script>